export const translate = {
  internationalize: (country, message) =>
    country === 'Argentina' || country === 'Uruguay'
      ? translate.ARG_UY[message]
      : translate.LATAM[message],
  ARG_UY: {
    title: '¡Hay muchas formas de ahorrar!',
    subtitle: 'Mirá todas las opciones debajo y cuidá tu bolsillo',
    tyc: 'Consultá los ',
    tooltip:
      'Podés agregar nuevos medios de pago cuando elijas como pagar tu pedido.',
    offer: 'Aprovechá',
    save: '¡Ahorrá',
    qcSubtitle: '¡Aprovechá hoy estos descuentos!',
    qcBannersTitle: '¡Disfrutá ofertas y novedades!',
    vendorItem: {
      ETA: {
        default: 'Envío con normalidad',
        quick: 'Envío rápido',
        delay: 'Envío con demora',
      },
      shipping: {
        plusFree: 'Envío gratis con PedidosYa Plus',
        plusDiscount: 'Envío con descuento de PedidosYa Plus',
      },
      images: {
        header: 'Imagen de portada del local',
        logo: 'Logo del local',
      },
    },
    jokerBannerTitle: 'Ahorrá hasta ',
    jokerBannerSubTitle: 'Probá nuevos sabores y disfrutá',
  },
  LATAM: {
    title: '¡Hay muchas formas de ahorrar!',
    subtitle: 'Mira todas las opciones debajo y cuida tu bolsillo',
    tyc: 'Consulta los ',
    tooltip:
      'Puedes agregar nuevos medios de pago cuando elijas como pagar tu pedido.',
    offer: 'Aprovecha',
    save: '¡Ahorra',
    qcSubtitle: '¡Aprovecha hoy estos descuentos!',
    qcBannersTitle: '¡Disfruta ofertas y novedades!',
    vendorItem: {
      ETA: {
        default: 'Envío con normalidad',
        quick: 'Envío rápido',
        delay: 'Envío con demora',
      },
      shipping: {
        plusFree: 'Envío gratis con PedidosYa Plus',
        plusDiscount: 'Envío con descuento de PedidosYa Plus',
      },
      images: {
        header: 'Imagen de portada del local',
        logo: 'Logo del local',
      },
    },
    jokerBannerTitle: 'Ahorra hasta ',
    jokerBannerSubTitle: 'Prueba nuevos sabores y disfruta',
  },
};
